import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import BeesInvoiceView from "../views/BeesInvoiceView";

const BeesInvoice: React.FC = () => {
    const { token } = useParams();
    const [searchParams] = useSearchParams();

    // Get specific query parameter
    const year = parseInt(searchParams.get('year') ?? "0");
    const month = parseInt(searchParams.get('month') ?? "0");

    return (
        <div className="ph-10">
            <BeesInvoiceView token={token ?? ""} year={year} month={month} />
        </div>
    );
};

export default BeesInvoice;